export default __webpack_public_path__ + "static/media/hotel-resort-img-18.2f7dc261.jpg";